import { createContext } from 'react';

export type TTypeOfCopyMenuModalWindow = null | 'toConfirmCopyMenu' | 'success' | 'error';

export interface ICopyMenuModalState {
	IDsSelectedRestaurantsToCopyMenu: string[];
	typeOfCopyMenuModalWindow: TTypeOfCopyMenuModalWindow;
}

export const copyMenuModalInitialState: ICopyMenuModalState = {
	IDsSelectedRestaurantsToCopyMenu: [],
	typeOfCopyMenuModalWindow: null,
};

export interface ICopyMenuModalContext extends ICopyMenuModalState {
	setIDsRestaurantsToCopyMenu(value: string[]): void;
	changeTypeOfCopyMenuModalWindow(value: TTypeOfCopyMenuModalWindow): void;
}

export const CopyMenuModalContext = createContext<ICopyMenuModalContext>({
	setIDsRestaurantsToCopyMenu: () => undefined,
	changeTypeOfCopyMenuModalWindow: () => undefined,
	...copyMenuModalInitialState,
});
